import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Report = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.neutral.white};
`;

export const ReportInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h2 {
    font-size: 16px;
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.neutral.black};
    opacity: 0.7;
  }

  a {
    font-size: 13px;
    width: fit-content;
  }
`;

export const Status = styled.strong`
  font-size: 13px;
  color: ${({ theme, status }) => {
    if (status === "Aprovado") return theme.colors.primary.vividCerulean;
    if (status === "Reprovado") return "#AD4A33";

    return theme.colors.neutral.black;
  }};
`;

export const Buttons = styled.div`
  display: flex;
  gap: 8px;

  button {
    width: 160px !important;
  }
`;
